import React from 'react';
import { select as selectStyle } from './trackUi';

export default function MemberPicker({ members, value, onChange, placeholder = '—', style, allowEmpty = true }) {
  const list = (members || []).filter((m) => m.isActive || String(m.id) === String(value));
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      onClick={(e) => e.stopPropagation()}
      style={{ ...selectStyle, ...style }}
    >
      {allowEmpty && <option value="">{placeholder}</option>}
      {list.map((m) => (
        <option key={m.id} value={m.id}>{m.name}{m.isActive ? '' : '（停用）'}</option>
      ))}
    </select>
  );
}
